export default {"src":"/_next/static/media/Linkedin.c5290ef0.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};